import Filters, { registerModuleFilters } from '@/utils/input/filters';

const { UserFilter, ProcessFilter, EnvironmentFilter } = Filters;

export const filtersConfig = [
  EnvironmentFilter,
  ProcessFilter,
  { ...UserFilter, name: 'destinationUserId' },
];

registerModuleFilters('delegationConfigurations', filtersConfig);
